import React from 'react';
import { Card, Typography } from '@mui/material';
import CustomTag from '../../../Components/CustomTag';
import { AppColors } from '../../../Utils/helper/AppColors';

const AnalyticsCard = ({
    heading,
    creadit,
    label,
    tagTitle = 'Credits Used',
    tagProps = {},
    cardProps = {},
    valueColor,
    labelColor,
    ...rest
}) => {
    // Format value: show .1 only if float, else integer
    const formatValue = (val) => {
        const num = Number(val || 0);
        return num % 1 === 0 ? Math.floor(num) : num.toFixed(1);
    };

    return (
        <Card
            sx={{
                minWidth: 290,
                width: 290,
                height: 250,
                p: 1,
                borderRadius: 2,
                border: `1px solid #EEEFF0`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
                boxShadow: '4px 4px 10px 2px #00000026',
                ...cardProps.sx,
            }}
            {...cardProps}
            {...rest}
        >
            <Typography
                sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: labelColor || AppColors.BLACK,
                    mb: 2,
                }}
            >
                {heading}
            </Typography>
            <Typography
                sx={(theme) => ({
                    fontSize: 36,
                    fontWeight: 600,
                    color: valueColor || theme.palette.primary.darker_primary || '#683FC7',
                    mb: 1,
                })}
            >
                {formatValue(creadit)}
            </Typography>
            <Typography
                sx={{
                    fontSize: 16,
                    fontWeight: 400,
                    color: AppColors.HEADING_TITLE4,
                    mb: 1,
                }}
            >
                {label}
            </Typography>
            <CustomTag
                tagTitle={tagTitle}
                borderRadius={'50px'}
                fontSize={14}
                fontWeight={400}
                minWidth={'150px'}
                maxWidth={'250px'}
                colorsInfo={{ border: '#DEE2E4', bgColor: '#EEEFF0', color: AppColors.HEADING_TITLE4 }}
                {...tagProps}
            />
        </Card>
    );
};

export default AnalyticsCard;